const { format, parse, parseISO, isValid, fromUnixTime } = require("date-fns");

// Most common date formats in order of specificity
const COMMON_FORMATS = [
  "yyyy-MM-dd",
  "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
  "yyyy-MM-dd'T'HH:mm:ssxxx",
  "yyyy-MM-dd HH:mm:ss",
  "MM/dd/yy",
  "MM/dd/yyyy",
  "M/d/yyyy",
  "dd/MM/yyyy",
  "d/M/yyyy",
  "MM-dd-yyyy",
  "M-d-yyyy",
  "MMMM d, yyyy",
  "MMM d, yyyy",
  "d MMMM yyyy"
];
const safeParse = (value) => {
  if (!value) return null;

  // Already a Date
  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  // Number (timestamp)
  if (typeof value === "number") {
    // Detect seconds vs milliseconds
    const date =
      value < 1e12
        ? new Date(value * 1000) // seconds
        : new Date(value); // milliseconds

    return isValid(date) ? date : null;
  }

  // String
  if (typeof value === "string") {
    // Try ISO first
    let date = parseISO(value);
    if (isValid(date)) return date;

    // Try SQL format: "YYYY-MM-DD HH:mm:ss"
    date = parse(value, "yyyy-MM-dd HH:mm:ss", new Date());
    if (isValid(date)) return date;

    // Try numeric string
    if (/^\d+$/.test(value)) {
      const num = Number(value);
      return safeParse(num);
    }
  }

  return null;
};

const toDate = (input, inputFormat = undefined, outputFormat = "MM/dd/yyyy") => {
  if (input === null || input === undefined) {
    return null;
  }

  let dateObj;

  if (inputFormat) {
    // Use provided format
    dateObj = parse(input, inputFormat, new Date());
  } else {
    // Try ISO format first (most common)
    try {
      dateObj = safeParse(input);
      if (isValid(dateObj)) {
        return format(dateObj, outputFormat);
      }
    } catch (e) {
      // Continue to try other formats
    }

    // Check if it's a Unix timestamp (number or string number)
    const numInput = Number(input);
    if (!isNaN(numInput)) {
      // If > 10 digits, assume milliseconds; otherwise seconds
      dateObj = numInput > 9999999999 ? new Date(numInput) : fromUnixTime(numInput);

      if (isValid(dateObj)) {
        return format(dateObj, outputFormat);
      }
    }

    // Try multiple common formats
    for (const fmt of COMMON_FORMATS) {
      try {
        dateObj = parse(input, fmt, new Date());
        if (isValid(dateObj)) {
          return format(dateObj, outputFormat);
        }
      } catch (e) {
        // Continue to next format
        continue;
      }
    }
  }

  return isValid(dateObj) ? format(dateObj, outputFormat) : null;
};

// Same function but with different default output format
const toPrettyDate = (input, inputFormat = undefined, outputFormat = "MMM d, yyyy") => {
  return toDate(input, inputFormat, outputFormat);
};

module.exports = {
  toDate,
  toPrettyDate,
  safeParse
};
